import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useTabsStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            gap: 20,
            height: 40,
            padding: 0,
            display: 'flex',
            flexDirection: 'row',
            borderRadius: 100,
            backgroundColor: '#F8F8F8',
            userSelect: 'none',

            [theme.breakpoints.up('md')]: {
                padding: 4
            }
        },
        tab: {
            gap: 6,
            flex: 1,
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 500,
            cursor: 'pointer',
            padding: '0px 16px',
            whiteSpace: 'nowrap',
            display: 'none',
            alignItems: 'center',
            borderRadius: 100,

            [theme.breakpoints.up('md')]: {
                display: 'inline-flex'
            }
        },
        selected: {
            color: '#fff',
            fontWeight: 600,
            display: 'inline-flex',
            backgroundColor: '#92B4A7'
        },
        icon: {
            [theme.breakpoints.up('md')]: {
                display: 'none'
            }
        },
        dropdown: {
            position: 'fixed',
            backgroundColor: 'red'
        },
        radio: {
            'color': '#000',
            'padding': '0px',
            'marginRight': 4,

            '& svg': {
                fill: '#000'
            }
        },
        countContainer: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            minWidth: 25
        },
        hidden: {
            visibility: 'hidden'
        },
        spinnerContainer: {
            position: 'absolute'
        },
        warning: {
            width: 10,
            height: 10,
            color: '#EAB464'
        }
    })
);
